module.exports = __webpack_public_path__ + "00164f8d1d21363aa6878c8d758a216e.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/EU.svg
// module id = uU8P
// module chunks = 0